export default {
    dataIterator: {
        rowsPerPageText: 'Elementos por página:',
        rowsPerPageAll: 'Todos',
        pageText: '{0}-{1} de {2}',
        noResultsText: 'No se encontraron registros',
        nextPage: 'Siguiente página',
        prevPage: 'Página anterior'
    },
    dataTable: {
        rowsPerPageText: 'Elementos por página:'
    },
    noDataText: 'No hay datos disponibles'
}